export default {
  'menu.home': 'Home',
  'menu.login': 'Sign In',
  'menu.register': 'Register',
  'menu.account': 'Account',
  'menu.account.logout': 'Logout',
  'menu.account.settings': 'Account Settings',
  'menu.account.staff-management': 'Staff Management',
  'menu.account.adminInvitations': 'Admin Invitations',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',

  // Adyen Balance Platform menus
  'menu.dashboard': 'Dashboard',
  'menu.merchants': 'Merchants',
  'menu.merchants.list': 'Merchant List',
  'menu.merchants.detail': 'Merchant Detail',
  'menu.merchants.balance-accounts': 'Balance Accounts',
  'menu.merchants.balance-account-detail': 'Balance Account Detail',
  'menu.transactions': 'Transactions',
  'menu.payouts': 'Payouts',
  'menu.reports': 'Reports',
  'menu.disputes': 'Disputes',
  'menu.settings': 'Settings',

  // Admin menus (SuperAdmin only)
  'menu.admin': 'Admin',
  'menu.admin.merchantOwners': 'Merchant Owners',
  'menu.admin.splitConfigurations': 'Split Configurations',
  'menu.adminInvitations': 'Admin Invitations',
  'menu.admin.adminInvitations': 'Admin Invitations',
  'menu.admin.adminSettings': 'Settings',
};
